<template>
  <base-link :href="source" target="_blank" relation="help">
    <base-icon name="notifications_question-circle" />
  </base-link>
</template>

<script>
import BaseLink from 'atoms/base/BaseLink';

export default {
  name: 'HelpLink',
  components: {
    BaseLink,
  },
  props: {
    source: {
      type: String,
      required: true,
    },
  },
};
</script>
